// @ts-nocheck
import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import OurProductsBlockData from "../../../Models/Content/SelfCareNavBarBlockData";
import OurProductsBar from "./OurProductsBar.js";

export default class OurProducts extends EpiComponent<OurProductsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return (
      <OurProductsBar context={this.getContext()} iContent={this.props.data} />
    );
  }
}
